const useData = [
  {
    id: 1,
    title: "Search my Property",
    description:
      "The Search My Property tool is a digital application (usually web or mobile based) that allows property owners, buyers, or municipal staff to locate, verify, and retrieve information about a specific property. It is commonly used in urban local bodies (ULBs), municipal corporations, and GIS-based land/property management systems.",
    steps: [
      "Open the Portal → Go to the Urban Data Analytics Center (GIS Based) portal.",
      "Navigate to the Search My Property option in the menu.",
      "Fill the Dropdowns → Select District, ULB, and Ward.",
      "Select Search Type → Choose ENP ID, Owner Name, or Mobile Number.",
      "Enter Property Details → Enter the value based on the selected search type.",
      "Click on 'Get Info' → The system will fetch property details and highlight the boundary.",
    ],
    detailedSteps: [
      "Open the Portal",
      "Go to the Urban Data Analytics Center (GIS Based) portal.",
      "Navigate to the Search My Property option in the menu.",
      "Fill the Dropdowns",
      "Select District → Choose the relevant district from the dropdown.",
      "Select ULB (Urban Local Body) → Pick the city/ULB.",
      "Select Ward → Select the specific ward within the ULB.",
      "Select Search Type → Choose how you want to search (ENP ID, Owner Name, or Mobile Number).",
      "Enter Property Details",
      "Enter the value based on the selected search type.",
      "Example: If “Owner Name” is selected, type the owner’s name.",
      "Click on 'Get Info'",
      "The system will fetch the property details and highlight the property boundary on the map.",
      "Property status will show whether the tax is paid or unpaid.",
    ],
    additionalFeatures: [
      "Identify how many properties are owned by the same person.",
      "Check complete tax details (current year, arrears, total).",
      "Visualize the property location on the GIS map.",
    ],

    // ✅ Added Hindi Translations
    hindi: {
      title: "मेरी संपत्ति खोजें",
      description:
        "‘मेरी संपत्ति खोजें’ टूल एक डिजिटल एप्लिकेशन है (आमतौर पर वेब या मोबाइल आधारित), जो संपत्ति मालिकों, खरीदारों या नगर निगम/पालिका कर्मचारियों को किसी विशेष संपत्ति का पता लगाने, सत्यापित करने और जानकारी प्राप्त करने में मदद करता है। इसका उपयोग शहरी स्थानीय निकायों (ULBs), नगर निगमों और GIS-आधारित भूमि/संपत्ति प्रबंधन प्रणालियों में किया जाता है।",
      steps: [
        "पोर्टल खोलें → Urban Data Analytics Center (GIS आधारित) पोर्टल पर जाएं।",
        "मेन्यू में ‘मेरी संपत्ति खोजें’ विकल्प पर क्लिक करें।",
        "ड्रॉपडाउन भरें → जिला, ULB और वार्ड चुनें।",
        "खोज प्रकार चुनें → ENP ID, मालिक का नाम या मोबाइल नंबर।",
        "संपत्ति विवरण दर्ज करें → चुने गए खोज प्रकार के आधार पर मान दर्ज करें।",
        "'जानकारी प्राप्त करें' पर क्लिक करें → सिस्टम संपत्ति का विवरण लाएगा और सीमा को हाइलाइट करेगा।",
      ],
      detailedSteps: [
        "पोर्टल खोलें",
        "Urban Data Analytics Center (GIS आधारित) पोर्टल पर जाएं।",
        "मेन्यू में ‘मेरी संपत्ति खोजें’ विकल्प पर जाएं।",
        "ड्रॉपडाउन भरें",
        "जिला चुनें → ड्रॉपडाउन से संबंधित जिला चुनें।",
        "ULB (Urban Local Body) चुनें → शहर/ULB चुनें।",
        "वार्ड चुनें → ULB के भीतर विशिष्ट वार्ड चुनें।",
        "खोज प्रकार चुनें → यह चुनें कि आप कैसे खोजना चाहते हैं (ENP ID, मालिक का नाम या मोबाइल नंबर)।",
        "संपत्ति विवरण दर्ज करें",
        "चुने गए खोज प्रकार के आधार पर मान दर्ज करें।",
        "उदाहरण: यदि “मालिक का नाम” चुना गया है, तो मालिक का नाम टाइप करें।",
        "'जानकारी प्राप्त करें' पर क्लिक करें",
        "सिस्टम संपत्ति का विवरण लाएगा और संपत्ति की सीमा को नक्शे पर हाइलाइट करेगा।",
        "संपत्ति की स्थिति यह दिखाएगी कि कर चुकाया गया है या नहीं।",
      ],
      additionalFeatures: [
        "देखें कि एक ही व्यक्ति की कितनी संपत्तियाँ हैं।",
        "पूरे कर विवरण की जांच करें (वर्तमान वर्ष, बकाया, कुल)।",
        "संपत्ति का स्थान GIS मानचित्र पर देखें।",
      ],
    },
  },

  {
    id: 2,
    title: "Buffer Analysis Tool",
    description:
      "The Buffer Analysis Tool is designed to identify properties and buildings located within a specified distance from important features such as roads, rivers, and railways. It is highly useful for urban planning and development activities including planning new road construction, road widening projects, identifying encroachments, and assessing developments near rivers, railways, and other infrastructure.",
    steps: [
      "Select Area of Interest – Choose the ULB or ward where analysis is required.",
      "Select Layer – Select the feature layer (e.g., Road, River, Railway) on which buffer is to be created.",
      "Choose Feature Name – Select the specific road, river, or railway line for analysis.",
      "Input Buffer Distance & Unit – Define the buffer distance (e.g., 100 m, 500 m, 1 km).",
      "Create Buffer – Click on the Create Buffer option to generate the zone of influence.",
      "View & Download Results – The tool will display all buildings and plots falling within the buffer distance.",
    ],
    detailedSteps: [
      "Select Area of Interest",
      "Choose the ULB or ward where analysis is required.",
      "Select Layer",
      "Select the feature layer (Road, River, Railway) for buffer creation.",
      "Choose Feature Name",
      "Select the specific road, river, or railway line for analysis.",
      "Input Buffer Distance & Unit",
      "Define the buffer distance (100 m, 500 m, 1 km).",
      "Create Buffer",
      "Click on 'Create Buffer' to generate the zone of influence.",
      "View & Download Results",
      "Review all buildings and plots within the buffer distance and download for decision-making.",
    ],
    additionalFeatures: [
      "Identify buildings or plots within a defined distance of infrastructure.",
      "Support planning and reporting for urban development.",
      "Export and use results for further analysis or decision-making.",
    ],
    useCases: [
      "Planning new road construction.",
      "Road widening projects.",
      "Identifying encroachments along fixed-width roads.",
      "Assessing developments near rivers, railways, and other infrastructure.",
    ],

    // ✅ Hindi Translation Added
    hindi: {
      title: "बफर विश्लेषण टूल",
      description:
        "बफर विश्लेषण टूल का उपयोग महत्वपूर्ण विशेषताओं जैसे सड़कें, नदियाँ और रेलवे से एक निर्दिष्ट दूरी के भीतर स्थित संपत्तियों और भवनों की पहचान करने के लिए किया जाता है। यह शहरी नियोजन और विकास गतिविधियों के लिए अत्यधिक उपयोगी है, जिसमें नई सड़क निर्माण की योजना, सड़क चौड़ीकरण परियोजनाएँ, अतिक्रमण की पहचान और नदियों, रेलमार्गों तथा अन्य बुनियादी ढाँचे के पास विकास का आकलन शामिल है।",
      steps: [
        "रुचि का क्षेत्र चुनें – वह ULB या वार्ड चुनें जहाँ विश्लेषण की आवश्यकता है।",
        "लेयर चुनें – वह फीचर लेयर चुनें (जैसे सड़क, नदी, रेलवे) जिस पर बफर बनाना है।",
        "फीचर नाम चुनें – विश्लेषण के लिए सड़क, नदी या रेलवे लाइन चुनें।",
        "बफर दूरी और इकाई दर्ज करें – बफर दूरी निर्धारित करें (जैसे 100 मी., 500 मी., 1 किमी)।",
        "बफर बनाएं – 'बफर बनाएं' विकल्प पर क्लिक करें ताकि प्रभाव क्षेत्र तैयार हो।",
        "परिणाम देखें और डाउनलोड करें – टूल सभी भवनों और भूखंडों को दिखाएगा जो बफर दूरी के भीतर आते हैं।",
      ],
      detailedSteps: [
        "रुचि का क्षेत्र चुनें",
        "वह ULB या वार्ड चुनें जहाँ विश्लेषण की आवश्यकता है।",
        "लेयर चुनें",
        "बफर बनाने के लिए फीचर लेयर चुनें (सड़क, नदी, रेलवे)।",
        "फीचर नाम चुनें",
        "विश्लेषण के लिए सड़क, नदी या रेलवे लाइन चुनें।",
        "बफर दूरी और इकाई दर्ज करें",
        "बफर दूरी निर्धारित करें (100 मी., 500 मी., 1 किमी)।",
        "बफर बनाएं",
        "'बफर बनाएं' पर क्लिक करें ताकि प्रभाव क्षेत्र तैयार हो।",
        "परिणाम देखें और डाउनलोड करें",
        "बफर दूरी के भीतर आने वाले सभी भवनों और भूखंडों की समीक्षा करें और निर्णय हेतु डाउनलोड करें।",
      ],
      additionalFeatures: [
        "बुनियादी ढाँचे से परिभाषित दूरी के भीतर भवनों या भूखंडों की पहचान करें।",
        "शहरी विकास के लिए योजना और रिपोर्टिंग को समर्थन दें।",
        "आगे के विश्लेषण या निर्णय लेने के लिए परिणामों को निर्यात और उपयोग करें।",
      ],
      useCases: [
        "नई सड़क निर्माण की योजना।",
        "सड़क चौड़ीकरण परियोजनाएँ।",
        "निश्चित चौड़ाई वाली सड़कों के साथ अतिक्रमण की पहचान।",
        "नदियों, रेलमार्गों और अन्य बुनियादी ढाँचे के पास विकास का आकलन।",
      ],
    },
  },

  {
    id: 3,
    title: "Identify New Properties",
    description:
      "The New Property Identification Tool is developed to identify and compare properties using GIS-based Urban Analytics. It integrates survey data with spatial analysis to detect newly constructed or unrecorded properties within Urban Local Bodies (ULBs).",
    steps: [
      "Select Area of Interest – Choose the District, ULB, and Ward where analysis is to be performed.",
      "System Fetches Property Data – The tool automatically retrieves surveyed properties and compares them with urban analytics results.",
      "View Results – Dashboard displays total properties, surveyed properties, and newly identified properties.",
      "Explore Property Details – Tabular data shows property IDs, ward numbers, ULB names, and unique GIS IDs.",
      "Download Results – Data can be downloaded for record keeping, validation, taxation, and decision-making.",
    ],
    detailedSteps: [
      "Select Area of Interest",
      "Choose the District, ULB, and Ward where analysis is to be performed.",
      "System Fetches Property Data",
      "The tool automatically retrieves surveyed properties and compares them with urban analytics results.",
      "View Results",
      "Dashboard displays total properties, surveyed properties, and newly identified properties.",
      "Explore Property Details",
      "Tabular data shows property IDs, ward numbers, ULB names, and unique GIS IDs for each identified property.",
      "Download Results",
      "Data can be downloaded for record keeping, validation, taxation, and decision-making.",
    ],
    additionalFeatures: [
      "Identify properties missed during manual surveys.",
      "Increase property tax base and revenue.",
      "Improve service delivery through updated property records.",
      "Support urban planning and infrastructure development.",
    ],
    useCases: [
      "Identifying properties missed during manual surveys.",
      "Increasing property tax base and revenue.",
      "Improving service delivery through updated property records.",
      "Supporting urban planning and infrastructure development.",
    ],

    // ✅ Hindi Translation Added
    hindi: {
      title: "नई संपत्तियों की पहचान करें",
      description:
        "नई संपत्ति पहचान टूल को GIS-आधारित शहरी विश्लेषण का उपयोग करके संपत्तियों की पहचान और तुलना करने के लिए विकसित किया गया है। यह सर्वेक्षण डेटा को स्थानिक विश्लेषण के साथ एकीकृत करता है ताकि शहरी स्थानीय निकायों (ULBs) के भीतर नव-निर्मित या अप्रतिबंधित संपत्तियों का पता लगाया जा सके।",
      steps: [
        "रुचि का क्षेत्र चुनें – वह जिला, ULB और वार्ड चुनें जहाँ विश्लेषण करना है।",
        "सिस्टम संपत्ति डेटा लाता है – टूल स्वतः सर्वेक्षित संपत्तियों को लाता है और उन्हें शहरी विश्लेषण परिणामों से तुलना करता है।",
        "परिणाम देखें – डैशबोर्ड कुल संपत्तियाँ, सर्वेक्षित संपत्तियाँ और नई पहचानी गई संपत्तियाँ दिखाता है।",
        "संपत्ति विवरण देखें – सारणीबद्ध डेटा संपत्ति ID, वार्ड नंबर, ULB नाम और अद्वितीय GIS ID दिखाता है।",
        "परिणाम डाउनलोड करें – डेटा को रिकॉर्ड रखने, सत्यापन, कराधान और निर्णय लेने के लिए डाउनलोड किया जा सकता है।",
      ],
      detailedSteps: [
        "रुचि का क्षेत्र चुनें",
        "वह जिला, ULB और वार्ड चुनें जहाँ विश्लेषण करना है।",
        "सिस्टम संपत्ति डेटा लाता है",
        "टूल स्वतः सर्वेक्षित संपत्तियों को लाता है और उन्हें शहरी विश्लेषण परिणामों से तुलना करता है।",
        "परिणाम देखें",
        "डैशबोर्ड कुल संपत्तियाँ, सर्वेक्षित संपत्तियाँ और नई पहचानी गई संपत्तियाँ दिखाता है।",
        "संपत्ति विवरण देखें",
        "सारणीबद्ध डेटा प्रत्येक पहचानी गई संपत्ति के लिए संपत्ति ID, वार्ड नंबर, ULB नाम और अद्वितीय GIS ID दिखाता है।",
        "परिणाम डाउनलोड करें",
        "डेटा को रिकॉर्ड रखने, सत्यापन, कराधान और निर्णय लेने के लिए डाउनलोड किया जा सकता है।",
      ],
      additionalFeatures: [
        "मैनुअल सर्वेक्षण के दौरान छूटी हुई संपत्तियों की पहचान करें।",
        "संपत्ति कर आधार और राजस्व बढ़ाएँ।",
        "अपडेटेड संपत्ति रिकॉर्ड के माध्यम से सेवा वितरण में सुधार करें।",
        "शहरी योजना और बुनियादी ढाँचे के विकास का समर्थन करें।",
      ],
      useCases: [
        "मैनुअल सर्वेक्षण के दौरान छूटी हुई संपत्तियों की पहचान करना।",
        "संपत्ति कर आधार और राजस्व बढ़ाना।",
        "अपडेटेड संपत्ति रिकॉर्ड के माध्यम से सेवा वितरण में सुधार करना।",
        "शहरी योजना और बुनियादी ढाँचे के विकास का समर्थन करना।",
      ],
    },
  },

  {
    id: 4,
    title: "Change Analysis Tool",
    description:
      "The Change Analysis module helps in comparing land use/land cover between two different years for a selected city/ULB. It provides a visual map comparison using a slider tool and a statistical table showing area differences in categories such as Agriculture, Built-up, Forest, Wasteland, and Waterbody. This analysis is useful for identifying urban growth, environmental changes, and planning future development.",
    steps: [
      "Open Change Analysis module from GIS Dashboard.",
      "Select Left Panel Year (e.g., 2022).",
      "Select Right Panel Year (e.g., 2024).",
      "Choose City/ULB from dropdown.",
      "Use the slider to compare both year maps.",
      "Check legend for land use categories.",
      "View Change Statistics table for area differences.",
    ],
    detailedSteps: [
      "Open Change Analysis module from GIS Dashboard.",
      "Select Left Panel Year (e.g., 2022).",
      "Select Right Panel Year (e.g., 2024).",
      "Choose City/ULB from dropdown.",
      "Use the slider to compare both year maps.",
      "Check legend for land use categories.",
      "View Change Statistics table for area differences.",
    ],
    additionalFeatures: [
      "Compare land use/land cover between two years.",
      "Identify urban growth and environmental changes.",
      "Support planning and future development.",
    ],
    useCases: [
      "Monitoring urban growth patterns.",
      "Identifying environmental changes.",
      "Planning future urban development.",
      "Comparing land use/land cover statistics for decision-making.",
    ],

    // ✅ Hindi Translation Added
    hindi: {
      title: "परिवर्तन विश्लेषण टूल",
      description:
        "परिवर्तन विश्लेषण मॉड्यूल चयनित शहर/ULB के लिए दो अलग-अलग वर्षों के बीच भूमि उपयोग/भूमि आवरण की तुलना करने में मदद करता है। यह स्लाइडर टूल का उपयोग करके दृश्य मानचित्र तुलना और एक सांख्यिकीय तालिका प्रदान करता है, जिसमें कृषि, निर्मित क्षेत्र, वन, बंजर भूमि और जल निकाय जैसी श्रेणियों में क्षेत्रीय अंतर दिखाया जाता है। यह विश्लेषण शहरी वृद्धि, पर्यावरणीय परिवर्तनों की पहचान करने और भविष्य के विकास की योजना बनाने में सहायक है।",
      steps: [
        "GIS डैशबोर्ड से परिवर्तन विश्लेषण मॉड्यूल खोलें।",
        "बाएँ पैनल वर्ष चुनें (जैसे 2022)।",
        "दाएँ पैनल वर्ष चुनें (जैसे 2024)।",
        "ड्रॉपडाउन से शहर/ULB चुनें।",
        "दोनों वर्षों के मानचित्रों की तुलना करने के लिए स्लाइडर का उपयोग करें।",
        "भूमि उपयोग श्रेणियों के लिए लीजेंड देखें।",
        "क्षेत्रीय अंतर देखने के लिए परिवर्तन सांख्यिकी तालिका देखें।",
      ],
      detailedSteps: [
        "GIS डैशबोर्ड से परिवर्तन विश्लेषण मॉड्यूल खोलें।",
        "बाएँ पैनल वर्ष चुनें (जैसे 2022)।",
        "दाएँ पैनल वर्ष चुनें (जैसे 2024)।",
        "ड्रॉपडाउन से शहर/ULB चुनें।",
        "दोनों वर्षों के मानचित्रों की तुलना करने के लिए स्लाइडर का उपयोग करें।",
        "भूमि उपयोग श्रेणियों के लिए लीजेंड देखें।",
        "क्षेत्रीय अंतर देखने के लिए परिवर्तन सांख्यिकी तालिका देखें।",
      ],
      additionalFeatures: [
        "दो वर्षों के बीच भूमि उपयोग/भूमि आवरण की तुलना करें।",
        "शहरी वृद्धि और पर्यावरणीय परिवर्तनों की पहचान करें।",
        "भविष्य की योजना और विकास का समर्थन करें।",
      ],
      useCases: [
        "शहरी वृद्धि पैटर्न की निगरानी।",
        "पर्यावरणीय परिवर्तनों की पहचान।",
        "भविष्य के शहरी विकास की योजना बनाना।",
        "निर्णय लेने के लिए भूमि उपयोग/भूमि आवरण सांख्यिकी की तुलना।",
      ],
    },
  },

  {
    id: 5,
    title: "Tax Evaluation Analysis",
    description:
      "The Tax Evaluation Analysis Module enables assessment of property tax status within a selected ward. It categorizes properties into assessed, under-assessed, and unassessed, while displaying their location on the map. This helps urban local bodies identify tax gaps and improve revenue collection.",
    steps: [
      "Open Tax Evaluation Analysis from the GIS Dashboard.",
      "Select District, ULB, and Ward from the dropdowns.",
      "The map will highlight the selected ward boundary.",
      "Property statistics will appear below the map (Total, Assessed, Under-Assessed, Unassessed).",
      "Use the Download Data button to export property data.",
    ],
    detailedSteps: [
      "Open Tax Evaluation Analysis from GIS Dashboard.",
      "Select District, ULB, and Ward from the dropdowns.",
      "Map highlights the selected ward boundary.",
      "View property statistics below the map including Total, Assessed, Under-Assessed, Unassessed.",
      "Property-wise data table displayed with Object ID, GIS Unique ID, Division, District, ULB, Ward, Ward Name.",
      "Download property data for record-keeping, validation, and taxation.",
    ],
    additionalFeatures: [
      "Assess property tax status ward-wise.",
      "Identify tax gaps.",
      "Improve revenue collection and fair taxation.",
    ],
    useCases: [
      "Ward-wise property tax evaluation.",
      "Identify under-assessed or unassessed properties.",
      "Support revenue improvement initiatives.",
    ],
    hindi: {
      title: "कर मूल्यांकन विश्लेषण",
      description:
        "कर मूल्यांकन विश्लेषण मॉड्यूल चयनित वार्ड के भीतर संपत्ति कर की स्थिति का आकलन करने में सक्षम बनाता है। यह संपत्तियों को आकलित, कम-आकलित और बिना आकलित श्रेणियों में विभाजित करता है, साथ ही उन्हें मानचित्र पर प्रदर्शित करता है। यह नगर निकायों को कर अंतर की पहचान करने और राजस्व संग्रह में सुधार करने में मदद करता है।",
      steps: [
        "GIS डैशबोर्ड से कर मूल्यांकन विश्लेषण खोलें।",
        "ड्रॉपडाउन से जिला, ULB और वार्ड चुनें।",
        "मानचित्र चयनित वार्ड की सीमा को हाइलाइट करेगा।",
        "संपत्ति आँकड़े मानचित्र के नीचे दिखाई देंगे (कुल, आकलित, कम-आकलित, बिना आकलित)।",
        "संपत्ति डेटा निर्यात करने के लिए 'डाउनलोड डेटा' बटन का उपयोग करें।",
      ],
      detailedSteps: [
        "GIS डैशबोर्ड से कर मूल्यांकन विश्लेषण खोलें।",
        "ड्रॉपडाउन से जिला, ULB और वार्ड चुनें।",
        "मानचित्र चयनित वार्ड सीमा को हाइलाइट करेगा।",
        "मानचित्र के नीचे संपत्ति आँकड़े देखें जिनमें कुल, आकलित, कम-आकलित और बिना आकलित शामिल हैं।",
        "संपत्ति-वार डेटा टेबल प्रदर्शित होगा जिसमें ऑब्जेक्ट ID, GIS यूनिक ID, डिवीजन, जिला, ULB, वार्ड, वार्ड नाम शामिल होंगे।",
        "रिकॉर्ड-कीपिंग, सत्यापन और कराधान के लिए संपत्ति डेटा डाउनलोड करें।",
      ],
      additionalFeatures: [
        "वार्ड-वार संपत्ति कर स्थिति का आकलन करें।",
        "कर अंतर की पहचान करें।",
        "राजस्व संग्रह और न्यायसंगत कराधान में सुधार करें।",
      ],
      useCases: [
        "वार्ड-वार संपत्ति कर मूल्यांकन।",
        "कम-आकलित या बिना आकलित संपत्तियों की पहचान।",
        "राजस्व सुधार पहलों का समर्थन करें।",
      ],
    },
  },

  {
    id: 6,
    title: "Tax Paid/ Unpaid",
    description:
      "The Tax Paid / Unpaid Module provides ward-wise insights into property tax collection. It highlights paid, unpaid, unregistered properties, and negative arrears for effective monitoring.",
    steps: [
      "Open Tax Paid / Unpaid from GIS Dashboard tools.",
      "Select District, ULB, and Ward from dropdowns.",
      "Map highlights the ward boundary.",
      "Property statistics displayed (Total MPHS, Tax Paid, Tax Unpaid, Not Registered, Negative Arrear).",
      "Properties color-coded on map based on payment status.",
      "Detailed property table displayed (Object ID, Owner Name, Address, Mobile, etc.).",
      "Use tabs to filter properties (Total, Paid, Unpaid, Not Registered, Negative Arrear).",
      "Data can be viewed and analyzed ward-wise.",
    ],
    detailedSteps: [
      "Open Tax Paid / Unpaid from GIS Dashboard.",
      "Select District, ULB, and Ward.",
      "Map highlights the ward boundary.",
      "View property statistics (Total MPHS, Tax Paid, Tax Unpaid, Not Registered, Negative Arrear).",
      "Detailed property table displayed with Object ID, Owner Name, Address, Mobile, etc.",
      "Use tabs to filter properties by status.",
      "Analyze data ward-wise for revenue improvement.",
    ],
    additionalFeatures: [
      "Ward-wise property tax monitoring.",
      "Track payment compliance and arrears.",
      "Highlight unregistered properties and negative arrears.",
    ],
    useCases: [
      "Track tax compliance across wards.",
      "Monitor unpaid and negative arrears.",
      "Support ULB revenue improvement initiatives.",
    ],
    hindi: {
      title: "कर भुगतान/अभुगतान",
      description:
        "कर भुगतान/अभुगतान मॉड्यूल वार्ड-वार संपत्ति कर संग्रह की जानकारी प्रदान करता है। यह भुगतान किए गए, बकाया, पंजीकृत न किए गए और नकारात्मक बकाया संपत्तियों को प्रभावी निगरानी के लिए हाइलाइट करता है।",
      steps: [
        "GIS डैशबोर्ड टूल्स से कर भुगतान/अभुगतान खोलें।",
        "ड्रॉपडाउन से जिला, ULB और वार्ड चुनें।",
        "मानचित्र वार्ड सीमा को हाइलाइट करेगा।",
        "संपत्ति आँकड़े प्रदर्शित होंगे (कुल MPHS, भुगतान किया गया कर, बकाया कर, अपंजीकृत, नकारात्मक बकाया)।",
        "संपत्तियों को भुगतान स्थिति के आधार पर मानचित्र पर रंग-कोड किया जाएगा।",
        "विस्तृत संपत्ति तालिका प्रदर्शित होगी (ऑब्जेक्ट ID, मालिक का नाम, पता, मोबाइल आदि)।",
        "संपत्तियों को फ़िल्टर करने के लिए टैब का उपयोग करें (कुल, भुगतान किया गया, बकाया, अपंजीकृत, नकारात्मक बकाया)।",
        "डेटा को वार्ड-वार देखा और विश्लेषण किया जा सकता है।",
      ],
      detailedSteps: [
        "GIS डैशबोर्ड से कर भुगतान/अभुगतान खोलें।",
        "जिला, ULB और वार्ड चुनें।",
        "मानचित्र वार्ड सीमा को हाइलाइट करेगा।",
        "संपत्ति आँकड़े देखें (कुल MPHS, भुगतान किया गया कर, बकाया कर, अपंजीकृत, नकारात्मक बकाया)।",
        "विस्तृत संपत्ति तालिका प्रदर्शित होगी जिसमें ऑब्जेक्ट ID, मालिक का नाम, पता, मोबाइल आदि होंगे।",
        "संपत्ति की स्थिति के अनुसार फ़िल्टर करने के लिए टैब का उपयोग करें।",
        "राजस्व सुधार के लिए वार्ड-वार डेटा का विश्लेषण करें।",
      ],
      additionalFeatures: [
        "वार्ड-वार संपत्ति कर की निगरानी।",
        "भुगतान अनुपालन और बकाया की ट्रैकिंग।",
        "अपंजीकृत संपत्तियों और नकारात्मक बकाया को हाइलाइट करें।",
      ],
      useCases: [
        "वार्ड स्तर पर कर अनुपालन की निगरानी।",
        "अभुगतान और नकारात्मक बकाया की निगरानी।",
        "ULB राजस्व सुधार पहलों का समर्थन।",
      ],
    },
  },

  {
    id: 7,
    title: "Geo-Info Query",
    description:
      "The GIS Query Tool is used to filter and analyze properties based on given conditions like plot size, floor type, or tax details. It helps officials quickly identify targeted properties and access ownership details.",
    steps: [
      "Open GIS Dashboard from the left menu.",
      "Select GIS Query option.",
      "Choose District → ULB → Property Data.",
      "Select attribute (e.g., plotsize) in the 'Where' section.",
      "Apply condition (e.g., > 1000 sqft).",
      "Enter value (e.g., 1000 sqft).",
      "Click Apply to view results.",
    ],
    detailedSteps: [
      "Open GIS Dashboard.",
      "Select GIS Query option.",
      "Choose the required District → ULB → Property Data.",
      "In the 'Where' section, select the attribute to filter (e.g., plotsize).",
      "Apply condition (e.g., greater than 1000 sqft).",
      "Enter the value to filter.",
      "Click Apply to view or download results.",
    ],
    additionalFeatures: [
      "Filter properties based on attributes like plot size, floor type, or tax details.",
      "Quickly identify and visualize targeted properties on map.",
      "Access property ownership details for decision-making.",
    ],
    useCases: [
      "Targeted property identification.",
      "Spatial analysis for urban planning.",
      "Decision support using property attributes.",
    ],
    hindi: {
      title: "भू-सूचना क्वेरी",
      description:
        "GIS क्वेरी टूल का उपयोग भूखंड आकार, फ़्लोर प्रकार या कर विवरण जैसी शर्तों के आधार पर संपत्तियों को फ़िल्टर और विश्लेषण करने के लिए किया जाता है। यह अधिकारियों को लक्षित संपत्तियों की शीघ्र पहचान करने और स्वामित्व विवरण प्राप्त करने में मदद करता है।",
      steps: [
        "बाएँ मेन्यू से GIS डैशबोर्ड खोलें।",
        "GIS क्वेरी विकल्प चुनें।",
        "जिला → ULB → संपत्ति डेटा चुनें।",
        "'Where' सेक्शन में गुण चुनें (जैसे: प्लॉट साइज़)।",
        "शर्त लागू करें (जैसे: > 1000 वर्ग फुट)।",
        "मान दर्ज करें (जैसे: 1000 वर्ग फुट)।",
        "परिणाम देखने के लिए Apply पर क्लिक करें।",
      ],
      detailedSteps: [
        "GIS डैशबोर्ड खोलें।",
        "GIS क्वेरी विकल्प चुनें।",
        "आवश्यक जिला → ULB → संपत्ति डेटा चुनें।",
        "'Where' सेक्शन में फ़िल्टर करने के लिए गुण चुनें (जैसे: प्लॉट साइज़)।",
        "शर्त लागू करें (जैसे: 1000 वर्ग फुट से अधिक)।",
        "फ़िल्टर के लिए मान दर्ज करें।",
        "परिणाम देखने या डाउनलोड करने के लिए Apply पर क्लिक करें।",
      ],
      additionalFeatures: [
        "भूखंड आकार, फ़्लोर प्रकार या कर विवरण जैसे गुणों के आधार पर संपत्तियों को फ़िल्टर करें।",
        "मानचित्र पर लक्षित संपत्तियों की शीघ्र पहचान और दृश्य प्राप्त करें।",
        "निर्णय लेने के लिए संपत्ति स्वामित्व विवरण तक पहुँच प्राप्त करें।",
      ],
      useCases: [
        "लक्षित संपत्ति की पहचान।",
        "शहरी योजना के लिए स्थानिक विश्लेषण।",
        "संपत्ति गुणों का उपयोग कर निर्णय समर्थन।",
      ],
    },
  },

  {
    id: 8,
    title: "View ULB/Print Map",
    description:
      "The View / Download ULB Map in GIS Dashboard allows users to save customized maps in multiple formats such as PDF, PNG, or JPEG. Exported maps contain ULB boundary, ward details, and highlighted properties.",
    steps: [
      "Open GIS Dashboard.",
      "Navigate to District → ULB → Ward Map.",
      "Click Export (Map Export Tool).",
      "Enter Title of File.",
      "Select Layout & Template (e.g., Letter ANSI A Landscape).",
      "Choose File Format (PDF/PNG/JPEG).",
      "Optional: Select Advanced Options like print area.",
      "Click Export → File will be downloaded.",
    ],
    detailedSteps: [
      "Open GIS Dashboard.",
      "Navigate to the required District → ULB → Ward Map.",
      "Click on Export (Map Export Tool).",
      "Enter the title of the file.",
      "Select Layout & Template (e.g., Letter ANSI A Landscape).",
      "Choose desired file format (PDF, PNG, JPEG).",
      "Optional: Select advanced options like print area.",
      "Click Export to download the file.",
    ],
    additionalFeatures: [
      "Export customized maps for reporting, presentations, and field verification.",
      "Include ULB boundary, ward details, and highlighted properties.",
      "Supports multiple file formats (PDF, PNG, JPEG).",
    ],
    useCases: [
      "Generate reports with visual maps.",
      "Field verification and documentation.",
      "Shareable maps for decision-making and presentations.",
    ],
    hindi: {
      title: "ULB देखें / मानचित्र प्रिंट करें",
      description:
        "GIS डैशबोर्ड में View / Download ULB Map विकल्प उपयोगकर्ताओं को अनुकूलित मानचित्रों को कई प्रारूपों जैसे PDF, PNG या JPEG में सहेजने की अनुमति देता है। निर्यात किए गए मानचित्रों में ULB सीमा, वार्ड विवरण और हाइलाइट की गई संपत्तियाँ शामिल होती हैं।",
      steps: [
        "GIS डैशबोर्ड खोलें।",
        "जिला → ULB → वार्ड मानचित्र पर जाएँ।",
        "Export (Map Export Tool) पर क्लिक करें।",
        "फ़ाइल का शीर्षक दर्ज करें।",
        "लेआउट और टेम्पलेट चुनें (जैसे: Letter ANSI A Landscape)।",
        "फ़ाइल प्रारूप चुनें (PDF/PNG/JPEG)।",
        "वैकल्पिक: प्रिंट क्षेत्र जैसी उन्नत विकल्प चुनें।",
        "Export पर क्लिक करें → फ़ाइल डाउनलोड हो जाएगी।",
      ],
      detailedSteps: [
        "GIS डैशबोर्ड खोलें।",
        "आवश्यक जिला → ULB → वार्ड मानचित्र पर जाएँ।",
        "Export (Map Export Tool) पर क्लिक करें।",
        "फ़ाइल का शीर्षक दर्ज करें।",
        "लेआउट और टेम्पलेट चुनें (जैसे: Letter ANSI A Landscape)।",
        "वांछित फ़ाइल प्रारूप चुनें (PDF, PNG, JPEG)।",
        "वैकल्पिक: प्रिंट क्षेत्र जैसी उन्नत विकल्प चुनें।",
        "Export पर क्लिक करें ताकि फ़ाइल डाउनलोड हो सके।",
      ],
      additionalFeatures: [
        "रिपोर्टिंग, प्रस्तुतियों और फील्ड सत्यापन के लिए अनुकूलित मानचित्र निर्यात करें।",
        "ULB सीमा, वार्ड विवरण और हाइलाइट की गई संपत्तियाँ शामिल करें।",
        "कई फ़ाइल प्रारूपों (PDF, PNG, JPEG) का समर्थन करता है।",
      ],
      useCases: [
        "दृश्य मानचित्रों के साथ रिपोर्ट तैयार करें।",
        "फील्ड सत्यापन और प्रलेखन।",
        "निर्णय लेने और प्रस्तुतियों के लिए साझा करने योग्य मानचित्र।",
      ],
    },
  },


  {
    id: 9,
    title: "Master Plan Analysis",
    description:
      "The Master Plan Analysis module allows users to visualize and analyze urban development plans, zoning regulations, and proposed land use within a city/ULB. It helps in comparing existing land use with planned land use to support better urban planning and decision-making.",
    steps: [
      "Open GIS Dashboard.",
      "Select the Master Plan Analysis option.",
      "Choose District → ULB → Ward/Area.",
      "View existing land use map overlaid with master plan/zoning layers.",
      "Use tools to zoom, pan, and explore different plan features.",
      "Download or export the master plan analysis map for reference.",
    ],
    detailedSteps: [
      "Open GIS Dashboard.",
      "From the menu, select Master Plan Analysis.",
      "Choose the required District, ULB, and Ward/Area.",
      "System overlays existing land use with proposed zoning and master plan layers.",
      "Use zoom and navigation tools to explore land use categories and zoning boundaries.",
      "Check legend for zoning categories (Residential, Commercial, Industrial, Green Zone, etc.).",
      "Export/download map and related data for planning and decision-making.",
    ],
    additionalFeatures: [
      "Visualize zoning regulations and land use proposals.",
      "Compare existing land use with master plan categories.",
      "Support urban planning, infrastructure development, and policy-making.",
    ],
    useCases: [
      "Urban planning and development control.",
      "Monitoring land use compliance with master plan.",
      "Supporting infrastructure and policy decisions.",
      "Identifying areas for redevelopment or preservation.",
    ],
    hindi: {
      title: "मास्टर प्लान विश्लेषण",
      description:
        "मास्टर प्लान विश्लेषण मॉड्यूल उपयोगकर्ताओं को शहरी विकास योजनाओं, ज़ोनिंग नियमों और प्रस्तावित भूमि उपयोग को देखने और विश्लेषण करने की अनुमति देता है। यह मौजूदा भूमि उपयोग की तुलना नियोजित भूमि उपयोग से करके बेहतर शहरी योजना और निर्णय लेने में मदद करता है।",
      steps: [
        "GIS डैशबोर्ड खोलें।",
        "मास्टर प्लान विश्लेषण विकल्प चुनें।",
        "जिला → ULB → वार्ड/क्षेत्र चुनें।",
        "मौजूदा भूमि उपयोग मानचित्र को मास्टर प्लान/ज़ोनिंग लेयर्स के साथ देखें।",
        "विभिन्न योजना विशेषताओं का पता लगाने के लिए ज़ूम, पैन और टूल्स का उपयोग करें।",
        "संदर्भ के लिए मास्टर प्लान विश्लेषण मानचित्र डाउनलोड या निर्यात करें।",
      ],
      detailedSteps: [
        "GIS डैशबोर्ड खोलें।",
        "मेन्यू से मास्टर प्लान विश्लेषण चुनें।",
        "आवश्यक जिला, ULB और वार्ड/क्षेत्र चुनें।",
        "सिस्टम मौजूदा भूमि उपयोग को प्रस्तावित ज़ोनिंग और मास्टर प्लान लेयर्स के साथ ओवरले करता है।",
        "भूमि उपयोग श्रेणियों और ज़ोनिंग सीमाओं का पता लगाने के लिए ज़ूम और नेविगेशन टूल्स का उपयोग करें।",
        "ज़ोनिंग श्रेणियों (आवासीय, वाणिज्यिक, औद्योगिक, हरित क्षेत्र आदि) के लिए लीजेंड जांचें।",
        "योजना और निर्णय लेने के लिए मानचित्र और संबंधित डेटा निर्यात/डाउनलोड करें।",
      ],
      additionalFeatures: [
        "ज़ोनिंग नियमों और भूमि उपयोग प्रस्तावों को देखें।",
        "मौजूदा भूमि उपयोग की तुलना मास्टर प्लान श्रेणियों से करें।",
        "शहरी योजना, बुनियादी ढांचा विकास और नीतिगत निर्णयों का समर्थन करें।",
      ],
      useCases: [
        "शहरी योजना और विकास नियंत्रण।",
        "भूमि उपयोग का मास्टर प्लान के अनुरूप अनुपालन की निगरानी।",
        "बुनियादी ढांचा और नीतिगत निर्णयों का समर्थन।",
        "पुनर्विकास या संरक्षण के लिए क्षेत्रों की पहचान।",
      ],
    },
  }

];

export default useData;
